import { IExitPointsAdjustmentHistoryRequest } from '@/app/core/interfaces/exit-points-adjustment-history.interface';

export class GetExitPointsAdjustmentHistoryAction {
  static readonly type =
    '[ExitPointsAdjustmentHistory] Get Exit Points Adjustment History';
  constructor(public payload: IExitPointsAdjustmentHistoryRequest) {}
}

export class ClearExitPointsAdjustmentHistoryAction {
  static readonly type =
    '[ExitPointsAdjustmentHistory] Clear Exit Points Adjustment History';
}

